module.exports = __webpack_public_path__ + "media/favicons/favicon_512-b158e630992381aabee5480351986cdc.png";